import { useQuery } from "@tanstack/react-query";

import {
  ApplicationsReportAPI,
  CountriesReportAPI,
  DiffrentReportAPI,
  GetAverageData,
  GetReportChart,
} from "./report.api";

export const reportKeys = {
  all: ["reports"],
  countries: () => [...reportKeys.all, "countries"],
  applications: () => [...reportKeys.all, "applications"],
  diffrent: () => [...reportKeys.all, "diffrent"],
  chart: () => [...reportKeys.all, "chart"],
  average: () => [...reportKeys.all, "average"],
};

export const useCountriesReportQuery = () =>
  useQuery({
    queryKey: reportKeys.countries(),
    queryFn: CountriesReportAPI,
  });

export const useApplicationsReportQuery = () =>
  useQuery({
    queryKey: reportKeys.applications(),
    queryFn: ApplicationsReportAPI,
  });

export const useDiffrentReportQuery = () =>
  useQuery({
    queryKey: reportKeys.diffrent(),
    queryFn: DiffrentReportAPI,
  });

export const useReportChartQuery = () =>
  useQuery({
    queryKey: reportKeys.chart(),
    queryFn: GetReportChart,
  });

export const useAverageDataQuery = () =>
  useQuery({
    queryKey: reportKeys.average(),
    queryFn: GetAverageData,
  });
